import React from "react";
import {
  BsBriefcaseFill,
  BsCalendar3,
  BsGeoAltFill,
} from "react-icons/bs";

const EXPERIENCES = [
  {
    id: 1,
    role: "Full Stack Developer Intern",
    company: "4xCode",
    location: "Lahore, Pakistan",
    period: "Jun 2026 – Present",
    type: "Internship",
    badge: "Current",
    color: "#6366f1",
    bullets: [
      "Built the company website using Next.js and integrated third-party APIs with Framer Motion animations.",
      "Developed responsive, fully optimised user interfaces adhering to modern UI/UX standards.",
      "Collaborated with the design team to translate Figma wireframes into production-ready components.",
    ],
    tech: ["Next.js", "Tailwind CSS", "Framer Motion", "API Integration"],
  },
  {
    id: 2,
    role: "Backend AI Engineer Intern",
    company: "FlyRank AI",
    location: "Remote",
    period: "Jul 2026 – Present",
    type: "Internship",
    badge: "Current",
    color: "#10b981",
    bullets: [
      "Developed and optimised backend APIs for AI-powered applications at production scale.",
      "Integrated AI services (LLM APIs, embeddings) into scalable Node.js backend solutions.",
      "Improved API response times and implemented caching strategies to reduce server load.",
    ],
    tech: ["Node.js", "Express.js", "REST APIs", "AI Integration", "MongoDB"],
  },
  {
    id: 3,
    role: "Software Engineering Fellow",
    company: "Dev Weekends Fellowship",
    location: "Remote",
    period: "Sep 2025 – Present",
    type: "Fellowship",
    badge: "Active",
    color: "#f59e0b",
    bullets: [
      "Collaborated on full-stack projects following industry-standard development workflows.",
      "Participated in structured code reviews, stand-ups, and sprint planning sessions.",
      "Contributed to open-source projects and built features in a team environment.",
    ],
    tech: ["React.js", "Node.js", "Git", "Agile", "Code Review"],
  },
];

function ExperienceSection() {
  return (
    <section id="experience" className="portfolio-section alt">
      <div className="section-container">
        <span className="section-label">Career</span>
        <h2 className="section-title">Work <span>Experience</span></h2>
        <p className="section-subtitle">
          Professional experience building real-world products in fast-moving teams.
        </p>
        <div className="section-divider" />

        {/* ── Vertical timeline ── */}
        <div className="timeline">
          {EXPERIENCES.map((exp, idx) => (
            <div className="tl-item" key={exp.id}>

              {/* Left column: dot + connector line */}
              <div className="tl-left">
                {/* Pulsing dot */}
                <div className="tl-dot" style={{ borderColor: exp.color, boxShadow: `0 0 0 4px ${exp.color}22` }}>
                  <BsBriefcaseFill style={{ color: exp.color }} />
                </div>
                {/* Vertical line — hide on last item */}
                {idx < EXPERIENCES.length - 1 && (
                  <div className="tl-line" />
                )}
              </div>

              {/* Right column: card */}
              <div className="tl-card" style={{ "--exp-color": exp.color }}>

                {/* Card top bar accent */}
                <div className="tl-card-bar" style={{ background: exp.color }} />

                {/* Header */}
                <div className="tl-card-header">
                  <div>
                    <h3 className="tl-role">{exp.role}</h3>
                    <span className="tl-company" style={{ color: exp.color }}>
                      @ {exp.company}
                    </span>
                  </div>
                  <span
                    className="tl-badge"
                    style={{
                      background: exp.color + "22",
                      color: exp.color,
                      borderColor: exp.color + "55",
                    }}
                  >
                    {exp.badge}
                  </span>
                </div>

                {/* Meta row */}
                <div className="tl-meta">
                  <span className="tl-meta-item">
                    <BsCalendar3 /> {exp.period}
                  </span>
                  <span className="tl-meta-item">
                    <BsGeoAltFill /> {exp.location}
                  </span>
                  <span
                    className="tl-type"
                    style={{
                      color: exp.color,
                      background: exp.color + "18",
                      borderColor: exp.color + "44",
                    }}
                  >
                    {exp.type}
                  </span>
                </div>

                {/* Bullet points */}
                <ul className="tl-bullets">
                  {exp.bullets.map((b, i) => (
                    <li key={i} className="tl-bullet">
                      <span className="tl-bullet-dot" style={{ background: exp.color }} />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>

                {/* Tech chips */}
                <div className="tl-tech-wrap">
                  {exp.tech.map((t) => (
                    <span
                      key={t}
                      className="tl-chip"
                      style={{ "--chip-color": exp.color }}
                    >
                      {t}
                    </span>
                  ))}
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExperienceSection;
